import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { IndicadoresAnalise } from '../../models/indicadores-analise.model';
import { IndicadoresAnaliseService } from '../../services/indicadores-analise.service';
import { IndicadoresPgAnaliseService } from '../../services/indicadores-pg-analise.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';

@Component({
  selector: 'app-detalhe-projeto-indicadores-analise-list',
  templateUrl: './detalhe-projeto-indicadores-analise-list.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-analise-list.component.scss']
})
export class DetalheProjetoIndicadoresAnaliseListComponent extends BaseListComponent<IndicadoresAnalise> implements OnInit, OnDestroy {

  @Input() idIndicador: number;
  @Input() idPgIndicador: number;
  @Input() type: string;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  analiseList: IndicadoresAnalise[];
  getAnalise: any;
  viewLastAnalises: boolean = false;

  constructor(
    private indicadoresAnaliseService: IndicadoresAnaliseService,
    private indicadoresPgAnaliseService: IndicadoresPgAnaliseService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    if (this.idIndicador) {
      this.addSub(
        this.indicadoresAnaliseService.getList(this.idIndicador).subscribe((res) => {
          this.getAnalise = res;
          this.analiseList = this.getAnalise?.analysis;
          this.loaded();
        })
      );
    } else if (this.idPgIndicador) {
      this.addSub(
        this.indicadoresPgAnaliseService.getList(this.idPgIndicador).subscribe((res) => {
          this.getAnalise = res;
          this.analiseList = this.getAnalise?.analysis;
          this.loaded();
        })
      );
    }
  }

  editar(id) {
    if (this.idIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'indicadores', 'analise', id, 'editar'];
    } else if (this.idPgIndicador) {
      return ['/projetos', this.type ?? 'agregador', 'indicadores', 'analise', id, 'editar'];
    }
  }

  novo() {
    if (this.idIndicador) {
      return ['/projetos', 'projeto', this.idProjeto, 'indicadores', 'analise', 'adicionar'];
    } else if (this.idPgIndicador) {
      return ['/projetos', this.type ?? 'agregador', 'indicadores', 'analise', 'adicionar'];
    }
  }

  novoParams() {
    if (this.idIndicador) {
      return { ind_id: this.idIndicador };
    } else if (this.idPgIndicador) {
      return { ind_id: this.idPgIndicador };
    }
  }

  novaDemandaLink() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar'];
  }

  novaDemandaParams(id: number) {
    return { pf_ind_analysis_id: id };
  }

  viewLast() {
    this.viewLastAnalises = !this.viewLastAnalises
  }

  confirmExcluir(id: number) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number) {
    this.loading();
    if (this.idIndicador) {
      this.indicadoresAnaliseService.delete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.idPgIndicador) {
      this.indicadoresPgAnaliseService.delete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    }
  }

}
